import React from 'react'
import './buttons.css'

const BaseButton =  ({text,callback}) =>{
    return(
    <button className='base-button' onClick={callback}> {text}</button>
    )
}

export{
    BaseButton
}